import loadable from "@loadable/component";
import { useParams } from "react-router";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import CreateIcon from "../../Icons/CreateIcon";
import { tw } from "@careinfo/tailwind";

const EditCustomerComponent = loadable(
  () => import("../../components/Customer/EditCustomer")
);
const EditCustomer = () => {
  const { id } = useParams();

  const { data, isLoading } = useGetHook({
    queryKey: [`customer-${id}`],
    url: `${APIS.CUSTOMER}${id}/`,
    params: {},
  });
  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["customer", `customer-${id}`],
    navigateURL: "/",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}${id}/`;

    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}>
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Edit Customer</span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditCustomerComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          data={data}
        />
      )}
    </>
  );
};
export default EditCustomer;
